import {
    Avatar,
    Card,
    CardBody,
    Rating,
    Typography,
  } from "@material-tailwind/react";
  
  export function CardReview({ name, feedback, date, rating }) {

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' });
        const year = date.getFullYear();
        return `${day} de ${month} de ${year}`;
    }

    // Convert rating to number
    const numericRating = Number(rating);

    return (
      <Card shadow={false}>
        <CardBody className="pt-0">
          <Rating value={numericRating} color="amber" readonly className="mb-6 text-amber-500" />
          <Typography className="text-base font-normal !text-gray-500">
            {feedback}
          </Typography>
          <div className="mt-6 flex items-center gap-4">
            <div>
              <Typography
                variant="h6"
                color="blue-gray"
                className="font-medium"
              >
                {name}
              </Typography>
              <Typography className="text-base font-normal !text-gray-500">
                {formatDate(date)}
              </Typography>
            </div>
          </div>
          <hr className="mt-6 mb-2 h-[1px] w-1/2 bg-gray-200 " />
        </CardBody>
      </Card>
    );
  }